import axios from "axios";
import store from "@/store";
import { Message } from "iview";
import { getToken, getLang } from "@/libs/util";
import { get } from "js-cookie";
import message from "@/utils/message";
import { isEmpty } from "@/libs/tools";
// import version from "@/utils/version";

const addErrorLog = errorInfo => {
  const {
    statusText,
    status,
    request: { responseURL }
  } = errorInfo;
  let info = {
    type: "ajax",
    code: status,
    mes: statusText,
    url: responseURL
  };
  // if (!responseURL.includes('save_error_logger')) store.dispatch('addErrorLog', info)
};
class HttpRequest {
  constructor(baseUrl = baseURL) {
    this.baseUrl = baseUrl;
    this.queue = {};
    this.isNoMsg = false;
  }
  getInsideConfig() {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: getToken(),
        lang: getLang()
      }
    };
    return config;
  }
  destroy(url) {
    delete this.queue[url];
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }
  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(
      config => {
        this.isNoMsg = false;
        // 添加全局的loading...
        if (!Object.keys(this.queue).length) {
          // Spin.show() // 不建议开启，因为界面不友好
        }
        this.queue[url] = true;
        if (config.method.toLowerCase() != "get") {
          if (!config.data) config.data = config.params;
          config.params = undefined;
        } else {
          if (!config.params) config.params = config.data;
          config.data = undefined;
        }
        if (config.isNoMsg) {
          this.isNoMsg = true;
        }
        return config;
      },
      error => {
        console.log(error);
        return Promise.reject(error);
      }
    );
    // 响应拦截
    instance.interceptors.response.use(
      res => {
        this.destroy(url);
        // if (res.config.method != "get") {
        //   version.getAjax(this);
        // }
        if (url === '/home') return res
        if (url.includes('signPic')) return res
        if (res.data.status) {
          const { data, status } = res;
          return { data, status };
        } else {
          if (this.isNoMsg) {
            return res;
          }
          Message.error({
            background: true,
            content: res.data.message || res.data.msg
          });
          return res;
        }
      },
      error => {
        this.destroy(url);
        let errorInfo = error.response;
        if (errorInfo.status == 401) {
          Message["error"]({
            background: true,
            content: errorInfo.data.message || errorInfo.data.msg
          });
          let VXE_TABLE_CUSTOM_COLUMN_VISIBLE = window.localStorage.getItem('VXE_TABLE_CUSTOM_COLUMN_VISIBLE');
          window.localStorage.clear();
          window.localStorage.setItem('VXE_TABLE_CUSTOM_COLUMN_VISIBLE', VXE_TABLE_CUSTOM_COLUMN_VISIBLE);
          window.location.href = "/";
        }
        const { data, status } = error.response;
        return { data, status };
        // console.log(errorInfo.data.msg);
        // this.$Message["error"](error.response.data.msg);
        // if (!errorInfo) {
        //   const {
        //     request: { statusText, status },
        //     config
        //   } = JSON.parse(JSON.stringify(error));
        //   errorInfo = {
        //     statusText,
        //     status,
        //     request: { responseURL: config.url }
        //   };
        // }
        // addErrorLog(errorInfo);
        // return Promise.reject(errorInfo.data.msg);
      }
    );
  }
  request(options) {
    const instance = axios.create();
    options = Object.assign(this.getInsideConfig(), options);
    this.interceptors(instance, options.url);
    return instance(options);
  }
}
export default HttpRequest;
